const SWIPE_THRESHOLD = 50;

document.querySelectorAll('.gallery-container').forEach((gallery) => {
  const images = gallery.querySelectorAll('.gallery-image');
  const nextBtn = gallery.querySelector('.gallery-nav--next');
  const prevBtn = gallery.querySelector('.gallery-nav--prev');
  let current = 1;

  function updateIndexes() {
    const total = images.length;

    images.forEach((img, i) => {
      const index = i + 1;
      let distance = current - index;

      if (distance > total / 2) distance -= total;
      if (distance < total / -2) distance += total;
      if (Math.abs(distance) > 2) distance = -100;

      img.dataset.index = distance;
    });

    let displayCurrent = current;
    if (current > total / 2) displayCurrent = current - total / 2;
    gallery.querySelector('[data-current-item]').textContent = displayCurrent;
  }

  function goNext() {
    current -= 1;
    if (current < 1) current = images.length;
    updateIndexes();
  }

  function goPrev() {
    current += 1;
    if (current > images.length) current = 1;
    updateIndexes();
  }

  nextBtn.addEventListener('click', goNext);
  prevBtn.addEventListener('click', goPrev);

  let startX = 0;
  let startY = 0;
  let tracking = false;
  let swiped = false;

  gallery.addEventListener('pointerdown', (event) => {
    if (event.button !== 0) return;
    tracking = true;
    swiped = false;
    startX = event.clientX;
    startY = event.clientY;
  });

  gallery.addEventListener('pointerup', (event) => {
    if (!tracking) return;
    tracking = false;

    const deltaX = event.clientX - startX;
    const deltaY = event.clientY - startY;

    if (Math.abs(deltaX) < SWIPE_THRESHOLD) return;
    if (Math.abs(deltaX) <= Math.abs(deltaY)) return;

    swiped = true;
    if (deltaX > 0) {
      goPrev();
    } else {
      goNext();
    }
  });

  gallery.addEventListener('pointercancel', () => {
    tracking = false;
  });

  // Overlay next/prev buttons would otherwise treat the swipe as a click.
  gallery.addEventListener(
    'click',
    (event) => {
      if (!swiped) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      swiped = false;
    },
    true
  );

  updateIndexes();
});
